"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RbiError2 = exports.RbiErrorDomain = void 0;
const http_status_codes_1 = __importDefault(require("http-status-codes"));
exports.RbiErrorDomain = {
    ORDER: 'ORDER',
    PARTNER_API: 'PARTNER_API',
    PAYMENT: 'PAYMENT',
    POS: 'POS',
};
/**
 * Standard error class. Used for server-to-server communication (REST API and AWS SQS requests) error handling.
 * It should be extended by error-specific class implementations when possible.
 *
 * In the future, it will replace RbiError!
 */
class RbiError2 extends Error {
    constructor(message, rbiErrorDomain, rbiErrorCode, properties, originalError, statusCode = http_status_codes_1.default.INTERNAL_SERVER_ERROR) {
        var _a;
        super(message);
        this.message = message;
        this.rbiErrorDomain = rbiErrorDomain;
        this.rbiErrorCode = rbiErrorCode;
        this.properties = properties;
        this.errorCode = rbiErrorDomain + '.' + rbiErrorCode;
        this.statusCode = statusCode;
        // assigning the class name of RbiError2, or the extended class
        // this.name is the standard Error.name property
        // this.errorName is used as an alternative property in logs, because the redact() function redacts 'name' properties
        this.name = this.errorName = new.target.name;
        // keeps the stack trace where the error is created
        (_a = Error.captureStackTrace) === null || _a === void 0 ? void 0 : _a.call(Error, this, this.constructor);
        // Capture the stack trace of the original error, if available
        if (originalError === null || originalError === void 0 ? void 0 : originalError.stack) {
            const originalStack = `\nCaused by: ${originalError.stack}`;
            this.stack = `${this.stack}${originalStack}`;
        }
    }
    static fromRbiErrorPayload(payload) {
        return new RbiError2(payload.message, payload.rbiErrorDomain, payload.rbiErrorCode, payload.properties, undefined, payload.statusCode);
    }
    static isRbiErrorPayload(payload) {
        return !!(payload === null || payload === void 0 ? void 0 : payload.rbiErrorCode) && !!(payload === null || payload === void 0 ? void 0 : payload.rbiErrorDomain);
    }
    toJSON() {
        return {
            errorCode: this.errorCode,
            errorName: this.errorName,
            message: this.message,
            rbiErrorCode: this.rbiErrorCode,
            rbiErrorDomain: this.rbiErrorDomain,
            statusCode: this.statusCode,
            ...this.properties,
        };
    }
}
exports.RbiError2 = RbiError2;
//# sourceMappingURL=rbi-error-2.js.map